/**
 * Silent telemetry collector for MIRA feedback widget.
 *
 * Captures the runtime context (URL, viewport, UA, role, console tail)
 * the user is NOT expected to fill in themselves. Bundled with the
 * first /feedback/chat call.
 */
import { getConsoleTail } from "./consoleCapture";

export function collectTelemetry(user, extras = {}) {
  if (typeof window === "undefined") {
    return { extras };
  }
  return {
    url: window.location.href,
    pathname: window.location.pathname + window.location.search,
    viewport: {
      w: window.innerWidth || 0,
      h: window.innerHeight || 0,
    },
    user_agent: navigator?.userAgent || "",
    role: user?.role || "viewer",
    plan: user?.plan || null,
    app_version: window.__SW_VERSION || null,
    console_tail: getConsoleTail(),
    extras,
  };
}
